import React from "react";

function CategoryButton({ category, filter }) {
    return (
      <button
        className="btn border-0 bg-transparent d-flex flex-column align-items-center gap-2 p-0 m-2 category-btn"
        onClick={() => filter(category.category_name)}
      >
        <div
          className="rounded-circle overflow-hidden shadow-sm border"
          style={{ width: '70px', height: '70px' }}
        >
          <img
            src={`${category.image_path}`}
            alt="Kategória képe"
            className="img-fluid w-100 h-100 object-fit-cover hover-zoom"
          />
        </div>
        <span className="text-center fw-medium small text-dark">
          {category.category_name}
        </span>
      </button>
    );
  };
  
  

export default CategoryButton;